export enum UrlConstant {
    Auth = 'Auth',
    Login = 'AuthenticateV1',
    Timer = "TimeExpenseEntry",
    Create = 'StartAndStopTimer',
    Update = 'Update',
    UpdateByResourceId='UpdateByResourceId',
    Delete = 'Delete',
    GetById = 'GetById',
    GetAll = 'GetAll',
    GetByFiltered = 'GetTimerDetailsByFiltered',
    GetByFilteredPaged = 'GetByFilteredPaged',
    GetRunningTimer = 'GetRunningTimer',
    MatterDependency = 'Matter',
    GetAllActiveRecord = 'GetAllActiveRecord',
    TimeExpenseEntry = 'TimeExpenseEntry',
    UserDependency = 'Employee',
    UTBMSCode = 'UTBMSCode',
    ActivityCategory = 'ActivityCategory',
    ExpenseCategory = 'ExpenseCategory',
    UTBMSDefaultGroup = 'UTBMSDefaultGroup',
    GetAllActiveRecords = 'GetAllActiveRecords',
    HourlyRates = 'HourlyRates',
    GetHourlyRatePriorityWise = 'GetHourlyRatePriorityWise',
    Tax = 'tax',
    Invoice = 'Invoice',
    CreateTimeEntryForInvoice = 'CreateTimeEntryForInvoice',
    CoCounsel = 'CoCounsel',
    TimeExpenseGetByFilteredpaged = 'TimeExpenseGetByFilteredpaged',
    TimeExpenseGetByFiltered = 'TimeExpenseGetByFiltered',
    GetAllActiveMatter = 'GetAllActiveMatter',
    CreateTimeExpenseEntry = 'CreateTimeExpenseEntry',
    DeleteTimeExpenseEntry = 'DeleteTimeExpenseEntry',
    UpdateTimeExpenseEntry = 'UpdateTimeExpenseEntry',
    GetActiveRecordByFilter='GetActiveRecordByFilter',
    GMailAddOn='GMailAddOn',
    CreateCommunication='CreateCommunication',
    UploadDocument='UploadDocument',
    GetCommunications='GetCommunications',
    DocumentV1='DocumentV1',
    GetByResourceId='GetByResourceId'
}
